import { Button, ModalTitle } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledModalTitle = styled(ModalTitle)`
  margin-bottom: -1rem;
`;

export const StyledButton = styled(Button)<{ width: string }>`
  background-color: ${({ theme }) => theme.colors.button.close.background};
  width: ${({ width }) => width}rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 34rem;
  }

  @media screen and (width: ${({ theme }) => theme.sizes.md}),
    screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    max-width: 100%;
  }
`;
